import { ChordLib } from '@tunasong/music-lib'
import type { ChordVariant } from '@tunasong/music-lib'
import type { FC } from 'react'
import { useState } from 'react'
import { TheoryCard } from '../window-tag/theory-card.js'
import styles from './mode-characteristic-chord.module.css'

export interface ModeCharacteristicChordProps {
  /** The mode's characteristic chord — always a major triad in v1 (§8.3). */
  chord: ChordVariant
  /** Lexicon id for the per-mode "Why?" TheoryCard (e.g., `mode-dorian-signature`). */
  modeLexiconId: string
}

/**
 * Mode Lab v1 characteristic-chord card. Renders the chord name + a Why?
 * affordance that toggles the existing `<TheoryCard>` popover. The popover
 * reuses the per-mode lexicon id so the body copy matches what the user has
 * already seen in-editor via the modal-signature chip.
 *
 * Visible only in the resting (non-comparing) state — the characteristic
 * chord belongs to the mode, not the parallel reference (§4.3).
 */
export const ModeCharacteristicChord: FC<ModeCharacteristicChordProps> = props => {
  const { chord, modeLexiconId } = props
  const [whyOpen, setWhyOpen] = useState(false)
  const chordName = ChordLib.getName(chord)
  return (
    <section className={styles.card} aria-label="Characteristic chord">
      <div className={styles.row}>
        <p className={styles.label}>Characteristic chord:</p>
        <p className={styles.chordName}>{chordName}</p>
        <button
          type="button"
          aria-label="Why?"
          aria-expanded={whyOpen}
          onClick={() => setWhyOpen(o => !o)}
          className={styles.whyButton}
        >
          Why?
        </button>
      </div>
      {whyOpen ? <TheoryCard lexiconId={modeLexiconId} /> : null}
    </section>
  )
}
